












import { defineComponent, computed } from '@vue/composition-api';

const CommonMediaTypeSelector = defineComponent({
  setup(props: any) {
    /* ==== Define creator group ==== */
    const mediaTypeId: number[] = [];
    const mediaTypeName: string[] = [];
    const mediaType = [
      { id: 1, display: 'วิดิโอ' },
      { id: 2, display: 'หนังสือ' },
      { id: 3, display: 'นิตยสาร' },
    ];
    mediaType.forEach((type) => {
      mediaTypeId.push(type.id);
      mediaTypeName.push(type.display);
    });

    const _value = computed(() => props.value);

    return {
      _value,
      mediaTypeName,
      mediaTypeId,
    };
  },
  props: {
    label: {
      type: String,
      default() { return ''; },
    },
    value: {
      type: String,
      default() { return ''; },
    },
  },
});

export default CommonMediaTypeSelector;
